<template>
  <div class="card p-3">
    <h1 class="title-pages pt-2">Históricos de Boletos emitidos</h1>
    <b-overlay :show="loading" opacity="0.99">
      <div class="text-end">
        <p class="m-0 worksansr">Total de boletos: {{ numberRegistration }}</p>

        <p class="m-0 worksansr">
          Valor a ser pago: {{ formatCurrencyBRL(valueToPaid) }}
        </p>

        <p class="m-0 worksansr">
          Total pago por unidade do boleto:
          {{ formatCurrencyBRL(valueToPaidBoleto) }}
        </p>
      </div>

      <div class="row mb-3">
        <div class="col-md-4">
          <label>Data Início</label>
          <input type="date" v-model="date_init" class="form-control" />
        </div>
        <div class="col-md-4">
          <label>Data Fim</label>
          <input type="date" v-model="date_end" class="form-control" />
        </div>

        <div class="col-md-4 d-flex align-items-end justify-content-start">
          <v-btn
            :disabled="loading"
            @click="getHistoryBoleto"
            small
            class="btn-filter w-25 h-50"
            ><i class="fas fa-filter mr-2'"></i> Filtrar
          </v-btn>
        </div>
      </div>

      <ErrorsMessages :errors="errors" />

      <v-data-table
        class="table-boleto-history"
        dense
        :headers="headers"
        :items="data"
        item-key="id"
        :footer-props="{
          'items-per-page-options': [500, 1000, 3000],
          'items-per-page-text': 'Mostrar',
        }"
        :options.sync="options"
        :server-items-length="numberRegistration"
      >
        <template v-slot:[`item.user_name`]="{ item }">
          <div style="cursor: pointer">
            <p
              class="m-0 limit-text worksansr"
              style="
                width: 300px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ item.user_name }}
            </p>
          </div>
          <v-tooltip bottom max-width="400"> </v-tooltip>
        </template>

        <template v-slot:[`item.boleto_nosso_numero`]="{ item }">
          <small>{{ item.boleto_nosso_numero }}</small>
        </template>

        <template v-slot:[`item.boleto_data`]="{ item }">
          <small>{{ formatDate(item.boleto_data, false) }}</small>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            x-small
            class="btn-edit m-1"
            :disabled="carregando"
            @click="handleBoletoSegundaVia(item)"
          >
            <i class="fas fa-barcode mr-2"></i>2ª via
          </v-btn>
        </template>
      </v-data-table>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import { formatCurrencyBRL, formatDate } from "../../lib/format";

import moment from "moment";

export default {
  name: "BoletoHistory",

  components: { ErrorsMessages },

  data() {
    return {
      data: [],

      numberRegistration: 0,
      valueToPaid: 0.0,
      valueToPaidBoleto: 0.0,

      loading: false,
      carregando: false,

      options: {},

      errors: [],

      date_init: moment().startOf("month").format("YYYY-MM-DD"),
      date_end: moment().endOf("month").format("YYYY-MM-DD"),

      headers: [
        { text: "Boleto emitido por:", value: "user_name", sortable: false },
        {
          text: "Data da emissão do boleto",
          value: "boleto_data",
          sortable: false,
        },
        {
          text: "Número do boleto",
          value: "boleto_nosso_numero",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatCurrencyBRL,
    formatDate,

    retrieve() {
      this.getHistoryBoleto();
    },

    async getHistoryBoleto() {
      try {
        this.loading = true;

        this.data = [];
        this.errors = [];
        this.numberRegistration = 0;
        this.valueToPaid = 0;
        this.valueToPaidBoleto = 0;

        let { date_init, date_end } = this;

        const params = { date_init, date_end };

        const response = await api.get("/history-boleto", { params });

        const { data, records, value, error, errors } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.data = data;
          this.numberRegistration = records;
          this.valueToPaid = value;
          this.valueToPaidBoleto = data.length > 0 ? data[0].boleto_value : 0;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    handleBoletoSegundaVia(item) {
      window.open(
        `https://app.boletocloud.com/boleto/2via/${item.boleto_token}`,
        "_blank"
      );
    },
  },
};
</script>

<style escoped>
.table-boleto-history .v-data-table__wrapper table {
  border: none !important;
}

.table-boleto-history .v-data-table__wrapper table tbody tr td {
  border: none !important;
}

.table-boleto-history .v-data-table__wrapper table thead tr th {
  border: none !important;
}

.table-boleto-history .v-data-table__wrapper table tbody tr:nth-child(even) {
  background-color: white !important;
}
</style>